import {
  f,
  u
} from "./chunk.775UL347.js";

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/property.js
var o = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f };
var r = (t = o, e4, r5) => {
  const { kind: n2, metadata: i } = r5;
  let s = globalThis.litPropertyMetadata.get(i);
  if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = /* @__PURE__ */ new Map()), "setter" === n2 && ((t = Object.create(t)).wrapped = true), s.set(r5.name, t), "accessor" === n2) {
    const { name: o3 } = r5;
    return { set(r6) {
      const n3 = e4.get.call(this);
      e4.set.call(this, r6), this.requestUpdate(o3, n3, t, true, r6);
    }, init(e5) {
      return void 0 !== e5 && this.C(o3, void 0, t, e5), e5;
    } };
  }
  if ("setter" === n2) {
    const { name: o3 } = r5;
    return function(r6) {
      const n3 = this[o3];
      e4.call(this, r6), this.requestUpdate(o3, n3, t, true, r6);
    };
  }
  throw Error("Unsupported decorator location: " + n2);
};
function n(t) {
  return (e4, o3) => "object" == typeof o3 ? r(t, e4, o3) : ((t2, e5, o4) => {
    const r5 = e5.hasOwnProperty(o4);
    return e5.constructor.createProperty(o4, t2), r5 ? Object.getOwnPropertyDescriptor(e5, o4) : void 0;
  })(t, e4, o3);
}

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/state.js
function r2(r5) {
  return n({ ...r5, state: true, attribute: false });
}

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/base.js
var e = (e4, t, c) => (c.configurable = true, c.enumerable = true, Reflect.decorate && "object" != typeof t && Object.defineProperty(e4, t, c), c);

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/query.js
function e2(e4, r5) {
  return (n2, s, i) => {
    const o3 = (t) => t.renderRoot?.querySelector(e4) ?? null;
    if (r5) {
      const { get: e5, set: r6 } = "object" == typeof s ? n2 : i ?? /* @__PURE__ */ (() => {
        const t = /* @__PURE__ */ Symbol();
        return { get() {
          return this[t];
        }, set(e6) {
          this[t] = e6;
        } };
      })();
      return e(n2, s, { get() {
        let t = e5.call(this);
        return void 0 === t && (t = o3(this), (null !== t || this.hasUpdated) && r6.call(this, t)), t;
      } });
    }
    return e(n2, s, { get() {
      return o3(this);
    } });
  };
}

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/query-all.js
var e3;
function r3(r5) {
  return (n2, o3) => e(n2, o3, { get() {
    return (this.renderRoot ?? (e3 ??= document.createDocumentFragment())).querySelectorAll(r5);
  } });
}

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/query-async.js
function r4(r5) {
  return (n2, e4) => e(n2, e4, { async get() {
    return await this.updateComplete, this.renderRoot?.querySelector(r5) ?? null;
  } });
}

// node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js
function o2(o3) {
  return (e4, n2) => {
    const { slot: r5, selector: s } = o3 ?? {}, c = "slot" + (r5 ? `[name=${r5}]` : ":not([name])");
    return e(e4, n2, { get() {
      const t = this.renderRoot?.querySelector(c), e5 = t?.assignedElements(o3) ?? [];
      return void 0 === s ? e5 : e5.filter((t2) => t2.matches(s));
    } });
  };
}

export {
  n,
  r2 as r,
  e2 as e,
  r3 as r2,
  r4 as r3,
  o2 as o
};
/*! Bundled license information:

@lit/reactive-element/decorators/property.js:
@lit/reactive-element/decorators/state.js:
@lit/reactive-element/decorators/base.js:
@lit/reactive-element/decorators/query.js:
@lit/reactive-element/decorators/query-all.js:
@lit/reactive-element/decorators/query-async.js:
@lit/reactive-element/decorators/custom-element.js:
@lit/reactive-element/decorators/event-options.js:
@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
